/* unplugin-vue-components disabled */import script from "./Trzfw.vue?vue&type=script&lang=ts&setup=true"
export * from "./Trzfw.vue?vue&type=script&lang=ts&setup=true"

import "./Trzfw.vue?vue&type=style&index=0&id=c339202a&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c339202a"]])

export default __exports__